import type { ColTypeDef } from 'ag-grid-community';
import { formatDuration } from 'date-fns';
import { useLocale } from 'hooks/useLocale';
import { useMemo } from 'react';

export function useTimespanColumnType<T>(): ColTypeDef<T> {
  const [locale] = useLocale();
  return useMemo(
    () => ({
      filter: 'agSetColumnFilter',
      valueFormatter: params => {
        const parts = params.value?.split(':')?.map((x: string) => parseInt(x, 10)) ?? [];

        if (parts?.length < 3) {
          return '';
        }

        const [hours, minutes, seconds] = parts;
        return formatDuration(
          {
            hours,
            minutes,
            seconds,
          },
          { locale },
        );
      },
    }),
    [locale],
  );
}
